import { render, staticRenderFns } from "./Webinari.vue?vue&type=template&id=2cef219a&scoped=true&"
import script from "./Webinari.vue?vue&type=script&lang=js&"
export * from "./Webinari.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cef219a",
  null
  
)

export default component.exports